import { render } from "./AppHeaderDefault.vue?vue&type=template&id=28874664"
import script from "./AppHeaderDefault.vue?vue&type=script&lang=js"
export * from "./AppHeaderDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__